import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { SMLRoutes } from '../../../routing/sml/SMLRoutes';
import { useSMLRouter } from '../../../routing/sml/hooks';
import { setUserToken } from '../../../redux/slices/appInfo/slice';
import { store as persistentStore } from '../../../store/Store';
import { useQueryParam } from '../../../utils/hooks/useQueryParam';
import { takeCoverDesignLink } from '../../coverEditor/carry/coverDesignLink';

/**
 * Stores the session token after a sign-in or a sign-up. The person then opens `returnTo` when the
 * link asked for a page, else the artist Home. The welcome is not decided here: the sign-in page
 * unmounts as soon as the token is in the store. The gate of the app shell (`useWelcomeRedirect`
 * in SMLContainer) holds Home and sends a new person to the welcome page.
 */
export const useAuthTokenSuccess = () => {
  const router = useSMLRouter();
  const dispatch = useDispatch();
  const queryReturnTo = useQueryParam('returnTo', null, '');
  // The link of the cover maker email carries a saved design (`coverDesign`): the sign-in then
  // opens the page that puts it on a song.
  const coverDesign = useQueryParam('coverDesign', null, '');

  return useCallback(
    (token: string) => {
      persistentStore.set('userToken', token).catch(console.error);
      dispatch(setUserToken({ token }));
      const returnTo = takeCoverDesignLink(coverDesign) ?? queryReturnTo;
      if (returnTo !== '') {
        window.location.href = `${window.location.origin}/app/${returnTo}`;
      } else {
        router.popToRoot();
        router.replace(SMLRoutes.home);
      }
    },
    [coverDesign, dispatch, queryReturnTo, router]
  );
};
